import { SELECT_ALL } from "./ComboboxUtils";
import { ComboboxItemVisual } from "./ComboboxItemVisual";
import { useEffect, useRef } from "react";
import { useCombobox } from "./ComboboxContext";
import styles from "../Combobox.module.scss";
import cx from "classnames";

const ComboboxSelectAll = function ({ className }: { className?: string }) {
  const {
    getItemProps,
    setForceCloseOnSelectItems,
    highlightedIndex,
    items,
    selectAll,
  } = useCombobox();

  const item = SELECT_ALL;
  const index = items.indexOf(item);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    return () => {
      setForceCloseOnSelectItems((forceCloseOnSelectItems) => {
        if (forceCloseOnSelectItems.includes(item)) {
          return forceCloseOnSelectItems.filter(
            (prevItem) => prevItem !== item,
          );
        } else {
          return forceCloseOnSelectItems;
        }
      });
    };
  }, [item, setForceCloseOnSelectItems]);

  return (
    <ComboboxItemVisual
      key="select-all"
      ref={ref}
      rootDivProps={getItemProps({
        item: SELECT_ALL,
        index,
        "aria-selected": highlightedIndex === index,
        className: cx(styles["select-all"], className),
      })}
      hideCheckbox={false}
      disabled={false}
      checked={!!selectAll?.isChecked}
    >
      {selectAll?.label}
    </ComboboxItemVisual>
  );
};

export { ComboboxSelectAll };
